/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Box_Label_Inspection_AllowedInputs */

const vi_box_label_inspection_allowed = /** @type {(inputs: Box_Label_Inspection_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cho xem hàng`)
};

/**

* @param {Box_Label_Inspection_AllowedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const box_label_inspection_allowed = /** @type {((inputs?: Box_Label_Inspection_AllowedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Box_Label_Inspection_AllowedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_box_label_inspection_allowed(inputs)
});